export default "__VITE_ASSET__HKNbX_zLs$syRs7flcFGow__"